import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ReleasesDashboard from 'containers/Releases/ReleasesDashboard';
function ReleasesRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: url },
            React.createElement(ReleasesDashboard, { url: url }))));
}
export default ReleasesRouts;
